import { hasValue } from '../helpers';
import { emojify, enlargeSingleEmoji } from '../helpers/emoji';
function getText(message) {
    switch (message.type) {
        case 'text':
            return message.body;
        case 'location':
            return message.location.description;
        case 'file':
            if (message.caption && message.caption.length > 0) {
                return message.caption;
            }
            else if (message.file.type === 'image/gif') {
                return 'GIF';
            }
            return message.file.name;
    }
    return message.caption;
}
export default [
    function () {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                message: '=',
                multiLine: '@?multiLine',
                linkify: '@?linkify',
            },
            link: function (scope, elem, attrs) {
                scope.$watch(() => scope.ctrl.message.id, (newId, oldId) => {
                    if (hasValue(newId) && newId !== oldId) {
                        scope.ctrl.updateText();
                    }
                });
                scope.$watch(() => scope.ctrl.message.caption, (newCaption, oldCaption) => {
                    if (hasValue(newCaption) && newCaption !== oldCaption) {
                        scope.ctrl.updateText();
                    }
                });
                scope.$watch(() => scope.ctrl.message, (newMessage, oldMessage) => {
                    if (newMessage !== oldMessage) {
                        scope.ctrl.updateText();
                    }
                }, false);
            },
            controllerAs: 'ctrl',
            controller: ['WebClientService', '$filter', function (webClientService, $filter) {
                    const escapeHtml = $filter('escapeHtml');
                    const markify = $filter('markify');
                    const mentionify = $filter('mentionify');
                    const linkify = $filter('linkify');
                    const nlToBr = $filter('nlToBr');
                    function processText(text, largeSingleEmoji, multiLine, linkifyText) {
                        const nonLinkified = mentionify(enlargeSingleEmoji(emojify(markify(escapeHtml(text))), largeSingleEmoji));
                        const maybeLinkified = linkifyText ? linkify(nonLinkified) : nonLinkified;
                        return nlToBr(maybeLinkified, multiLine);
                    }
                    this.updateText = () => {
                        const multiLine = (this.multiLine === undefined || this.multiLine !== 'false');
                        const linkifyText = (this.linkify === undefined || this.linkify !== 'false');
                        const text = getText(this.message);
                        this.text = processText(text, this.largeSingleEmoji, multiLine, linkifyText);
                    };
                    this.largeSingleEmoji = webClientService.appConfig.largeSingleEmoji;
                    this.$onInit = function () {
                        this.updateText();
                    };
                }],
            template: `
                <span click-action ng-bind-html="ctrl.text"></span>
            `,
        };
    },
];
